import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

/* PIPES */
import { EcertDisplayDirective } from '@directives';
import { PipesModule } from '@pipes/pipes.module';
@NgModule({
    imports: [BrowserModule, PipesModule],
    declarations: [EcertDisplayDirective],
    exports: [EcertDisplayDirective, PipesModule],
    providers: []
})
export class GlobalServicesModule { }
